var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BA0D2328-0349-4FFE-B945-982DA367CA30") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Current",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Appointment-Details",
    transform: "translate(-239.000000, -575.000000)",
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clock-circular-outline",
    transform: "translate(239.000000, 575.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5,0 C3.8131021,0 0,3.8131021 0,8.5 C0,13.1868979 3.8131021,17 8.5,17 C13.1868979,17 17,13.1868979 17,8.5 C17,3.8131021 13.1868979,0 8.5,0 Z M8.5,15.1913442 C4.8104261,15.1913442 1.80848086,12.1897489 1.80848086,8.5 C1.80848086,4.81025113 4.8104261,1.80865583 8.5,1.80865583 C12.1895739,1.80865583 15.1915191,4.81025113 15.1915191,8.5 C15.1915191,12.1897489 12.1895739,15.1913442 8.5,15.1913442 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4088437,7.74509804 L9.1823126,7.74509804 L9.1823126,3.62745098 C9.1823126,3.28094118 8.91762237,3 8.5911563,3 C8.26469023,3 8,3.28094118 8,3.62745098 L8,8.37254902 C8,8.71905882 8.26469023,9 8.5911563,9 L12.4088437,9 C12.7353098,9 13,8.71905882 13,8.37254902 C13,8.02603922 12.7353098,7.74509804 12.4088437,7.74509804 Z",
    id: "Path"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d7f81be75a006f07dd3a5e09f7756d19.svg";
export { ForwardRef as ReactComponent };